/* Independent, progressively enhanced sliders. Native Ride commerce stays untouched. */
if (!customElements.get('rc-slider')) {
  customElements.define('rc-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.rcReady) return;
      this.rcReady = true;
      const track = this.querySelector('[data-rc-track]');
      const previous = this.querySelector('[data-rc-prev]');
      const next = this.querySelector('[data-rc-next]');
      const count = this.querySelector('[data-rc-count]');
      if (!track) return;
      this.rcAbort = new AbortController();
      const signal = this.rcAbort.signal;
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        const slides = [...track.children];
        const index = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
        if (count) count.textContent = slides.length ? `${index + 1} / ${slides.length}` : '';
      };
      const move = direction => {
        const first = track.firstElementChild;
        const step = first ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth;
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous?.addEventListener('click', () => move(-1), {signal});
      next?.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      }, {signal});
      this.rcResize = new ResizeObserver(update);
      this.rcResize.observe(track);
      for (const image of track.querySelectorAll('img')) image.addEventListener('load', update, {once:true, signal});
      update();
    }
    disconnectedCallback() { this.rcAbort?.abort(); this.rcResize?.disconnect(); this.rcReady = false; }
  });
}
